import React, { useCallback, memo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  ProtocolListWithHeader,
  useBreadcrumb,
} from 'components';
import {
  deleteProtocol,
  loadRecentProtocols,
  loadProtocolTypes,
} from 'reduxModules/protocols';
import {
  getProtocolsToDisplay,
  getUsedProtocolTypes,
} from 'reduxModules/protocols/selectors';

const breadcrumbLevels = [{ text: 'Dashboard' }, { text: 'Recent' }];

export function RecentProtocols() {
  const dispatch = useDispatch();

  const protocolsToDisplay = useSelector(getProtocolsToDisplay);
  const types = useSelector(getUsedProtocolTypes);
  const loading = useSelector((state) => state.protocols.loading);
  const sendingProtocol = useSelector((state) => state.protocols.sendingProtocol);

  const handleDeleteClick = useCallback(
    (id) => {
      dispatch(deleteProtocol(id));
    },
    [dispatch]
  );

  const handleMount = useCallback(async () => {
    await dispatch(loadRecentProtocols());
    dispatch(loadProtocolTypes());
  }, [dispatch]);

  useBreadcrumb(breadcrumbLevels);

  return (
    <ProtocolListWithHeader
      loading={loading}
      types={types}
      onDeleteClick={handleDeleteClick}
      sendingProtocol={sendingProtocol}
      protocolsToDisplay={protocolsToDisplay}
      headingTitle="Recent Protocols"
      onMount={handleMount}
    />
  );
}

export default memo(RecentProtocols);
